import { Button } from 'components/Button/Button'

import style from './SetPoseConfirmCard.module.css'

type Props = {
  onCancel: () => void
  onConfirm: () => void
}

const SetPoseConfirmCard = ({ onCancel, onConfirm }: Props) => (
  <div className={style.setPoseCard}>
    <div className={style.setPoseTitle}>Set Robot Pose</div>
    <div className={style.setPoseDesc}>
      Drag the robot icon to set its position, and drag the direction arrow to adjust its heading.
    </div>
    <div className={style.setPoseButtons}>
      <Button.Standart className={style.setPoseBtn} onClick={onCancel}>
        Cancel
      </Button.Standart>
      <Button.Standart className={style.setPoseBtn} onClick={onConfirm}>
        Confirm
      </Button.Standart>
    </div>
  </div>
)

export default SetPoseConfirmCard
